/**
 * Sticky Add-to-Cart Bar
 * - Appears when the real ATC scrolls out of view
 * - Mirrors price (from selected purchase option), button text, and disabled/sold-out state
 * - Uses IntersectionObserver + MutationObserver — no scroll listeners, no layout shift
 *
 * CONFIG
 * ──────
 * SHOW_ON_LOAD  true  → sticky shows immediately if the real ATC is already off-screen on page load
 *               false → sticky only appears after the user has scrolled past the real ATC at least once
 */

(function () {
  'use strict';
    if(window.innerWidth > 767 || isNotProductUrl(window.location.href) ){
      return false;
    }
    function isNotProductUrl(url) {
      return !/\/products\/[^/]+/.test(url);
    }
  const SHOW_ON_LOAD = false; // ← change to true to show on load if ATC is off-screen

  /* ─── 1. Inject styles (once) ─────────────────────────────────────── */
  const STYLE_ID = 'sticky-atc-styles';
  if (!document.getElementById(STYLE_ID)) {
    const css = `
      #sticky-atc-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
        transform: translateY(100%);
        transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
        will-change: transform;
        padding:10px;
      }
      #sticky-atc-bar.is-visible {
        transform: translateY(0);
      }
      #sticky-atc-bar .satc-price-wrap {
        display: flex;
        min-width: 0;
        flex-shrink: 0;
            gap: 10px;
                width: 50%;
    border-right: 1px solid #9b9b9b;
    justify-content:center;
      }
            .satc-title {
    font-weight: 700;
    /* letter-spacing: 1px; */
}
      #sticky-atc-bar .satc-price {
        font-size: 1.1rem;
        font-weight: 700;
        color: #9b9b9b;
        white-space: nowrap;
      }
        .satc-product-content {
    color: #fff;
    line-height:normal;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
      #sticky-atc-bar .satc-label {
        font-size: 12px;
        color: #9b9b9b;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 80px;
        display:block;
            font-weight: 700;
      }
      #sticky-atc-bar .satc-btn {
        flex: 1;
        max-width: 360px;
        margin-left: auto;
        background: #000;
        color: #fff;
        border: 2px solid #fff;
        padding:15px 10px;
        border-radius: 999px;
        font-size: 16px;
        font-weight: 700;
        letter-spacing:0;
        cursor: pointer;
        transition: background 0.18s, opacity 0.18s;
        white-space: nowrap;
        text-align: center;
      }
      #sticky-atc-bar .satc-btn:hover:not(:disabled) {
        background: #000;
      }
      #sticky-atc-bar .satc-btn:disabled,
      #sticky-atc-bar .satc-btn[data-soldout="true"] {
        opacity: 0.5;
        cursor: not-allowed;
        background: #555;
      }
   .satc-inner {
    display: flex;
    gap: 15px;
    background: #000;
    padding: 10px;
    border-radius: 20px;
    align-items:center;
}
        .satc-product-image img {
            width: 60px;
            height: 60px;
            object-fit: contain;
            border-radius:10px;
        }
    `;
    const styleEl = document.createElement('style');
    styleEl.id = STYLE_ID;
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  /* ─── 2. Build bar DOM (once) ─────────────────────────────────────── */
  if (document.getElementById('sticky-atc-bar')) return; // guard double-init

  const bar = document.createElement('div');
  bar.id = 'sticky-atc-bar';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = `
  <div class="satc-inner">
    <div class="satc-price-wrap">
    <div class="satc-product-image">
        <img src="${document.querySelector('#main-product-image')?.getAttribute('src')}"/>
    </div>
    <div class="satc-product-content">
        <div class="satc-title">${document.querySelector('.product-info__title-pdp')?.textContent}</div>
      <span class="satc-price" id="satc-price">—</span>
      <span class="satc-label" id="satc-label"></span>
      </div>
    </div>
    <button class="satc-btn" id="satc-btn" type="button">Add to cart</button>
    </div>
  `;
  document.body.appendChild(bar);

  const stickyBtn   = bar.querySelector('#satc-btn');
  const stickyPrice = bar.querySelector('#satc-price');
  const stickyLabel = bar.querySelector('#satc-label');

  /* ─── 3. Helpers ──────────────────────────────────────────────────── */

  /**
   * Read price + label from whichever purchase radio is currently selected.
   * Falls back gracefully if elements are missing.
   */
  function getSelectedPriceInfo() {
    const checked = document.querySelector(
      '.product-pack__purchase-pdp input[name="purchase"]:checked'
    );
    if (!checked) return { price: '', label: '' };

    const wrapper = checked.closest('label');
    if (!wrapper) return { price: '', label: '' };

    const isSubscription = checked.value === 'subscription';

    if (isSubscription) {
      const priceEl = wrapper.querySelector('.price-subscribe');
      const price   = priceEl ? priceEl.textContent.trim() : '';
      // Show selected frequency
      const select  = document.getElementById('frequency-select');
      const label   = select
        ? select.options[select.selectedIndex]?.text?.trim()
        : 'Subscribe & Save';
      return { price, label };
    } else {
      const priceEl = wrapper.querySelector('.price-onetime');
      const price   = priceEl ? priceEl.textContent.trim() : '';
      return { price, label: 'One-time purchase' };
    }
  }

  /**
   * Mirror the real ATC button's state into the sticky bar.
   * Checks: disabled attribute, text content, sold-out classes.
   */
  function syncFromRealATC() {
    const realBtn = document.querySelector(
      '.product-info__buttons-pdp .add-to-cart-btn'
    );
    if (!realBtn) return;

    const isSoldOut =
      realBtn.disabled ||
      realBtn.classList.contains('sold-out') ||
      realBtn.classList.contains('disabled') ||
      /sold.?out|unavailable/i.test(realBtn.textContent);

    const btnText = realBtn.textContent.trim() || 'Add to cart';

    stickyBtn.textContent = btnText;
    stickyBtn.disabled    = isSoldOut;
    stickyBtn.dataset.soldout = isSoldOut ? 'true' : 'false';

    // Price
    const { price, label } = getSelectedPriceInfo();
    stickyPrice.textContent = price;
    stickyLabel.textContent = label;
  }

  /* ─── 4. Show / hide via IntersectionObserver ─────────────────────── */
  const realATCWrapper = document.querySelector('.product-info__buttons-pdp');

  if (realATCWrapper) {
    // True only after the user has scrolled the ATC out of view downward
    // (i.e. ATC is above the viewport). Resets to false when ATC re-enters.
    let hasScrolledPast = false;

    const io = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;

        if (entry.isIntersecting) {
          // ATC is back in view — reset flag and always hide sticky
          hasScrolledPast = false;
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
          return;
        }

        // ATC is out of view — check if it exited from the top (user scrolled past it downward)
        // boundingClientRect.top < 0 means the element is above the viewport
        const isBelow = entry.boundingClientRect.top < 0;

        if (isBelow) hasScrolledPast = true;

        // Show only if: user has scrolled past it downward
        // AND (SHOW_ON_LOAD allows it on first load OR user actively scrolled past)
        const shouldShow = hasScrolledPast || (SHOW_ON_LOAD);

        if (shouldShow) {
          syncFromRealATC();
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        }
      },
      {
        rootMargin: '0px 0px 0px 0px',
        threshold: 0,
      }
    );

    io.observe(realATCWrapper);
  }

  /* ─── 5. MutationObserver — react to real ATC DOM changes ────────── */
  const realBtn = document.querySelector(
    '.product-info__buttons-pdp .add-to-cart-btn'
  );
  if (realBtn) {
    const mo = new MutationObserver(() => {
      if (bar.classList.contains('is-visible')) syncFromRealATC();
    });
    mo.observe(realBtn, {
      attributes: true,
      characterData: true,
      subtree: true,
      childList: true,
    });
  }

  /* ─── 6. React to purchase option / frequency changes ─────────────── */
  const purchaseSection = document.querySelector('.product-pack__purchase-pdp');
  if (purchaseSection) {
    purchaseSection.addEventListener('change', () => {
      if (bar.classList.contains('is-visible')) syncFromRealATC();
    });
  }

  /* ─── 7. Sticky button action — delegate to real ATC ─────────────── */
  stickyBtn.addEventListener('click', () => {
    if (stickyBtn.disabled) return;

    const realAddToCart = document.querySelector(
      '.product-info__buttons-pdp .add-to-cart-btn'
    );
    if (realAddToCart && !realAddToCart.disabled) {
      realAddToCart.click();
    }
  });

})();
(function () {
  const MIN = 1, MAX = 99;

  function onQuantityChange(id, quantity) {
   // new code
  }

  document.querySelectorAll('.qs').forEach(function (qs) {
    var valEl = qs.querySelector('.qs-val');
    var decBtn = qs.querySelector('[aria-label="Decrease"]');
    var incBtn = qs.querySelector('[aria-label="Increase"]');
    var qty = 1;

    function update(delta) {
      qty = Math.min(MAX, Math.max(MIN, parseInt(valEl.textContent) + delta));
      valEl.textContent = qty;
      decBtn.disabled = qty <= MIN;
      incBtn.disabled = qty >= MAX;
      if (delta !== 0) onQuantityChange(qs.id, qty);
    }

    decBtn.addEventListener('click', function () { 
      update(-1); 
      document.querySelector('.product-pack__option-pdp:has(input:checked) .pack-content .pack-qty-minus').click();
    });
    incBtn.addEventListener('click', function () { 
      update(1);
      document.querySelector('.product-pack__option-pdp:has(input:checked) .pack-content .pack-qty-plus').click();
     });

    update(0);
  });
})();
document.querySelectorAll('.sub-happy__video').forEach(video => {
  video.addEventListener('play', function() {
    document.querySelectorAll('.sub-happy__video').forEach(otherVideo => {
      if (otherVideo !== this) {
        otherVideo.pause();
      }
    });
  });
});